export * from '@primeuix/themes/aura/imagecompare';
export { default } from '@primeuix/themes/aura/imagecompare';
